var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8287 41.6049V48.4827",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.1289,
    y: 25.5565,
    width: 11.4311,
    height: 16.0484,
    rx: 2.27909,
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6958 43.8975V48.4827",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8369 37.0196H26.5543",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8369 30.1417H26.5543",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8369 23.2639H26.5543",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8443 25.5565V9.5082C44.8443 8.24202 43.8207 7.21558 42.5581 7.21558H20.839C19.5763 7.21558 18.5527 8.24202 18.5527 9.5082V16.3861",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12109 48.4827V18.6786C7.12109 17.4124 8.14467 16.386 9.40732 16.386H29.9833C31.246 16.386 32.2696 17.4124 32.2696 18.6786V48.4827",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83496 48.4827H50.5594",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.7c90ee7dc6288b79011fb8b3e18e728e.svg";
export { ForwardRef as ReactComponent };